import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import _ from "lodash";
import Select from "react-select";
import { Field, reduxForm } from "redux-form";
import moment from "moment";
import "./styles.css";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  MDBDataTable,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import MySelect from "../../../../shared/components/form/MySelect";
import Util from '../../../Common/util';
import API from '../../../Common/api';

var url = window.location.hostname;
var port = window.location.port;

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';



function accessCookie(cookieName) {
  var name = cookieName + "=";
  var allCookieArray = document.cookie.split(";");
  for (var i = 0; i < allCookieArray.length; i++) {
    var temp = allCookieArray[i].trim();
    if (temp.indexOf(name) == 0)
      return temp.substring(name.length, temp.length);
  }
  return "";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const options = {
  textLabels: {
    body: {
      noMatch: "Data is Loading...",
    },
  },
  selectableRows: false,
  sort: false,
  download: false,
  print: false,
  viewColumns: false,
  filter: false,
  pagination: true,
  search: true,
  setRowProps: (row) => {},
  onCancel: false,
  task_id:"",
  
};

const exportToCSV = (csvData, fileName) => {
	if(csvData.length === 0){
		csvData = [{
		"Bin Address": "",
		"Recommended Date": ""
	    }];
	}
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    FileSaver.saveAs(data, fileName + fileExtension);
  }
const optionsUser = [];

class HorizontalForm extends PureComponent {
  state = {
	binData: [],
	newArrayData1: [],
	successModal: false,
    data_for_recommendation: [],
    consolidation_response: [],
    data_for_task: [],
    userName: "",
    selectedLocation: "",
    showBinConsolidationTable: false,
    modalAssignUser: false,
    options: [],
    showZone: false,
    selected_zone_option: [],
    showTaskTable: true,
    selected: {},
    selected_all: false,
    selectedUser: {},
    optionsUser: [],
    uniqueZoneData: {},
    DisableAssignbutton: true,
	reasonText: null,
    createTaskBtnDisabled: false,
    showPendingNote: false,
	cancelDisableBtn: true,
	recommended_selected:{},
	modalAssignUser: false,
	modalAssignUserCycleCount: false,
	alertMessage:"",
	messageModalCycle:false,
	modalfailedCycle: false,
	totalScanCount: "",
  };
  
  fetchUserList = () => {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/auth/users/getusers', { param: payload })
      .then((response) => {
        for (var i = 0; i < response.data.length; i++) {
          
          var orderData = {};
          orderData["label"] = response.data[i].userName;
          orderData["value"] = response.data[i].userId;

          optionsUser.push(orderData);
        }

        /* console.log(this.state.options);*/
      })
      .catch(function (error) {});
  }
  
  messageToggleCycle =() => {
    this.setState({
      messageModalCycle: true,
    });
  }
  
  failedToggleCycle =() => {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({
      modalfailedCycle: !prevState.modalfailedCycle,
    }));
  }
  
  failedToggleCancelCycle =()=> {
    this.setState({
      modalfailedCycle: false,
    });

    window.location.reload();
  }

  
  
  processData1 =() => {
    this.setState({
      loadingprintbtn: true,
    });

    var arr = [];

    _.map(this.state.selectedUser, (item, key) => {
      var bin_arr = [];
      var orderData = {};
      console.log(key);
      console.log(item);
      orderData["zone"] = parseInt(key);
      orderData["users"] = item[0];
      /*item[1].map(( item1 , index ) => (
        console.log(item1)
        bin_arr.push(item1.bin_address.push)


      ))*/

      item[1].map((item1) => {
        console.log(item1.bin_address);
        bin_arr.push(item1.id);
      });

      orderData["bins"] = bin_arr;

      arr.push(orderData);
    });

    console.log("ARR - ",arr);
    
    const payload = {
      create: false,
      location: this.state.selectedLocation,
      req_type: "cc",
      cycle_data: arr,
  };

API.post('/cycle_count/createCycleCount/v1/', { param: payload })
      .then((response) => {
        console.log(response);
        if (response.data.status_code === 201) {
          this.setState({
            failedMessage: response.data.reason,
          });
          this.toggleAssignUserCycleCount();
          this.failedToggleCycle();
        }

        if (
          response.data.status_code === 200 &&
          response.data.failed.length === 0
        ) {
          this.setState({
            alertMessage: "Are you sure you want to confirm ? ",
          });
          this.toggleAssignUserCycleCount();
          this.messageToggleCycle();
        }

        if (
          response.data.status_code === 200 &&
          response.data.failed.length > 0
        ) {
          this.setState({
            failedMessage: "This file contains some errors",
            showBinTable: false,
            showZone: false,
            showFailedItemCycle: true,
            FailedItems: response.data.failed,
          });
          this.toggleAssignUserCycleCount();
          this.failedToggleCycle();
        }
      })
      .catch(function (error) {});
  }

  toggleAssignUserCycleCount =() => {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({
      modalAssignUserCycleCount: !prevState.modalAssignUserCycleCount,
    }));
  } 
  cancelMessageModalCycle =() => {
    var arr = [];

    _.map(this.state.selectedUser, (item, key) => {
      var bin_arr = [];
      var orderData = {};
      console.log(key);
      console.log(item);
      orderData["zone"] = parseInt(key);
      orderData["users"] = item[0];
      /*item[1].map(( item1 , index ) => (
        console.log(item1)
        bin_arr.push(item1.bin_address.push)


      ))*/

      item[1].map((item1) => {
        console.log(item1.bin_address);
        bin_arr.push(item1.id);
      });

      orderData["bins"] = bin_arr;

      arr.push(orderData);
    });

    console.log(arr);

    const payload = {
      create: true,
      location: this.state.selectedLocation,
      req_type: "cc",
      cycle_data: arr,
  };

API.post('/cycle_count/createCycleCount/v1/', { param: payload })
      .then((response) => {
        this.setState({
          messageModalCycle: false,
        });
        this.successToggle();
      })
      .catch(function (error) {});
  }
  
  AssignUser =() => {
    this.setState({
      selectedUser: {},
      modalAssignUserCycleCount: true,
      selectedOptions: "",
      newArrayData1: [],
    });

    console.log(this.state.binData);
    var arrayCartData = this.state.binData.filter(
      (item) => item.isChecked === true
    );
    console.log(arrayCartData);
    this.setState({
      newArrayData1: arrayCartData,
    });
    console.log(this.state.newArrayData);

    var arr = [];

    for (var i = 0; i < arrayCartData.length; i++) {
      arr.push(arrayCartData[i].id);
    }
    //arr = [4341];
    console.log(arr);

    const payload = {
      bins: arr,
  };

API.post('/cycle_count/fetchCycleCountScanCount/v1/', { param: payload })
      .then((response) => {
        console.log(response);
        this.setState({
          totalScanCount: response.data.ScanCount,
        });

        console.log(this.state.totalScanCount);
      })
      .catch(function (error) {});
  }	
  successToggle =() => {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({ successModal: !prevState.successModal }));
    window.location.reload();
  }
  recommendationclick = () => {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/cycle_count/cycleCountRecommendedReport/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
		//var data = [{"bin_Id":"1234","binAddress":"A-1-1-1","recommendedDate":"2020-01-31","zone_Name":"Nail1","zone_Id":"1"}]
		let updated_data_2 = data.map((row, index) => {
		  var checkbox_name = index + "_" + row["id"]+"_"+row["zoneId"]+"_"+row["zoneName"]+"_"+row["binAddress"];
          var checkbox_html = (
            <input
              type="checkbox"
              name={checkbox_name}
              className="checkbox_div"
              selected={this.state.selected[checkbox_name]}
              onChange={this.handleRecommendedClick}
            />
          );
		console.log(checkbox_name);
		console.log(checkbox_html);	
          return {
			checkbox: checkbox_html,  
            BinAddress: row["binAddress"],
            RecommendedDate: row["recommendedDate"],
            
          };
        });

        this.setState({
          data_for_recommendation: updated_data_2,
        });
      })
      .catch(function (error) {});
  };
  
  handleRecommendedClick = (e) => {
    const selected = this.state.selected;
    selected[e.target.name] = e.target.checked;
    this.setState({ selected }, () => {
      var sp_checked_status = [];
	  var binData = [];
		
	for (let binAddressId in this.state.selected) {
	  if (this.state.selected[binAddressId] == true) {
		let splitted_val = binAddressId.split("_");
		let reqId = splitted_val[0];
		sp_checked_status.push(reqId);
		binData.push({
			id: splitted_val[1],
			isChecked: true,
			zone__zone_code: splitted_val[3],
			zone_id: splitted_val[2],
			bin_address: splitted_val[4],
		});
	  }
	}

      if (sp_checked_status.length > 0) {
        this.setState({
          cancelDisableBtn: false,
		  binData:binData,
          //pickHisIdToCancel: cancel_checked_status,
        });
      } else {
        this.setState({
          cancelDisableBtn: true,
		  binData:binData,
          //pickHisIdToCancel: cancel_checked_status,
        });
      }
    });
  };
  
  handleallCheckBoxClick = (e) => {
    const selected_all = e.target.checked;
    const selected = this.state.selected;

    const checkboxes = document.getElementsByClassName("checkbox_div");
    
    for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked != e.target.checked) {
          document.getElementsByName(checkboxes[i].name)[0].click();
        }
    }
    
    this.setState(
      {
        selected: selected,
      },
      () => {
        var sp_checked_status = [];
		var binData = [];
		
        for (let binAddressId in this.state.selected) {
          if (this.state.selected[binAddressId] == true) {
			let splitted_val = binAddressId.split("_");
			let reqId = splitted_val[0];
            sp_checked_status.push(reqId);
			binData.push({
				id: splitted_val[1],
				isChecked: true,
				zone__zone_code: splitted_val[3],
				zone_id: splitted_val[2],
				bin_address: splitted_val[4],
			});
          }
        }
        if (sp_checked_status.length > 0) {
          this.setState({
            cancelDisableBtn: false,
			binData:binData,
          });
        } else {
          this.setState({
            cancelDisableBtn: true,
			binData:binData,
          });
        }
      }
    );

    this.setState({
      selected_all: selected_all,
    });
  };
  
createBatch = () => {
    var arr = [];
    for (let binAddressId in this.state.selected) {
          if (this.state.selected[binAddressId] == true) {
			arr.push(binAddressId.split("_")[1]);
          }
        }
    const payload = {
      create: true,
      location: this.state.selectedLocation,
      req_type: "cc",
      cycle_data: arr,
  };

API.post('/cycle_count/createCycleCount/v1/', { param: payload })
      .then((response) => {
        console.log(response);
        this.successToggle();
      })
      .catch(function (error) {});
  }

  onChangeVal = (options, id, bin_items) => {
    const { selectedUser } = this.state;
    console.log(options);
    /*selectedUser[id] = options.map(item => [item.value])*/
    var data = [];
    for (var i = 0; i < options.length; i++) {
      data.push(options[i]["value"]);
    }
    console.log(data);
    selectedUser[id] = [];
    selectedUser[id].push(data);
    selectedUser[id].push(bin_items);
    this.setState(
      {
        selectedUser,
      },
      (e) => console.log(this.state.selectedUser)
    );
  };
  
  componentDidMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8090";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = getCookie("token");
    var Location = getCookie("selectedLocation");
    var username = accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,
      },
      () => {
		this.fetchUserList();
        this.recommendationclick();
        
      }
    );

    localStorage.setItem("userName", username);
  }


  render() {
	const uniqueZoneData1 = {};  
	const { modalAssignUser, modalAssignUserCycleCount } = this.state;  
	
	this.state.newArrayData1.map((item) => {
      if (!uniqueZoneData1[item.zone_id]) {
        uniqueZoneData1[item.zone_id] = {
          zoneId: item.zone_id,
          zoneName: item.zone__zone_code,
          items: [],
        };
      }
      uniqueZoneData1[item.zone_id].items.push(item);
    });
    const recommendedData = {
      columns: [
		{
                    label: (
                      <input
                        type="checkbox"
                        name="select_all_checkbox"
                        selected={false}
                        onChange={this.handleallCheckBoxClick}
                      />
                    ),
                    name: "checkbox",
					width: 50,
        },
        
        {
          label: "Bin Address",
          field: "BinAddress",
          sort: "disabled",
          width: 100,
        },
        {
          label: "Recommended Date",
          field: "RecommendedDate",
          sort: "disabled",
          width: 150,
        },

        ],
      rows: this.state.data_for_recommendation,
    };

    

    return (
      <div className="col-xl-12">
        <Card>

            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header" style={{borderBottomWidth:'0px'}}>
              <button
                    color="primary"
                    className="btn btn-primary btn-sm pull-left"
                    style={{
                      margin: "0px",
                      marginLeft: "10px",
                      textTransform: "capitalize",
                    }}
                    disabled={this.state.cancelDisableBtn}
                    onClick={this.AssignUser}
                  >
                    Create Batch
                  </button>
				  {/*<span
                    className="pull-right"
                    onClick={(e) => exportToCSV(this.state.data_for_recommendation, "CC_Recommendation_Report")}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>*/}
				  {/*<Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.posts, this.state.fileNameVal)}>Download Excel</Button>*/}
            </div>
			<hr style={{marginTop:'30px',marginBottom:'0px'}}/>
              <div>
                <MDBDataTable
                  striped
                  bordered
                  hover
                  data={recommendedData}
                  scrollX={true}
                  sorting={false}
                />
              </div>
            </CardBody>
          

        </Card>
		
		<Modal isOpen={this.state.successModal} toggle={this.successToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.successToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> Batch Created Successfully </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.successToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
		
		<Modal
          isOpen={modalAssignUserCycleCount}
          toggle={this.toggleAssignUserCycleCount}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <div>
              <span style={{ fontWeight: "bold", fontSize: 16 }}>
                {" "}
                Estimated Scan Count :{" "}
                <span style={{ color: "red" }}>
                  {" "}
                  {this.state.totalScanCount}{" "}
                </span>{" "}
              </span>
            </div>
            <Table
              responsive
              className="table--bordered"
              style={{ marginBottom: 75 }}
            >
              <thead>
                <tr>
                  <th>Zone Id</th>
                  <th>Zone Name</th>
                  <th> Bin Count </th>
                  <th>Users</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(uniqueZoneData1).length > 0 &&
                  _.map(uniqueZoneData1, (item, key) => (
                    <tr key={key}>
                      <td>{item.zoneId}</td>
                      <td>{item.zoneName} </td>
                      <td>{item.items.length} </td>
                      <td>
                        <div
                          className="form__form-group"
                          style={{ width: "100%" }}
                        >
                          <div
                            style={{ width: "100%" }}
                            className="form__form-group-field"
                          >
                            <MySelect
                              style={{ width: "100%" }}
                              isMulti
                              name={`multiSelect_${item.zoneId}`}
                              value={this.state.selectedUser[item.zoneId]}
                              onChange={(selectedOptions) =>
                                this.onChangeVal(
                                  selectedOptions,
                                  item.zoneId,
                                  item.items
                                )
                              }
                              options={optionsUser}
                              clearable={true}
                              closeOnSelect={true}
                              removeSelected={true}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            <ButtonToolbar className="modal__footer">
              <button
                  className="modal_cancel"
                onClick={this.toggleAssignUserCycleCount}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData1}
              >
                {this.state.loadingprintbtn && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Confirm
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>
		
		<Modal isOpen={this.state.modalfailedCycle} toggle={this.failedToggleCycle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.failedToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.failedMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
                  className="modal_cancel"
              onClick={this.failedToggleCancelCycle}
            >
              Cancel
            </button>
          </ButtonToolbar>
        </Modal>
		
		<Modal isOpen={this.state.messageModal} toggle={this.messagetoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.alertMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              style={{  marginRight: 8 }}
              className="modal_cancel"
              onClick={this.toggle}
            >
              Cancel
            </button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.cancelMessageModal}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
		
		<Modal isOpen={this.state.messageModalCycle} toggle={this.messageToggleCycle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.messageToggleCycle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.alertMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              style={{marginRight: 8 }}
              className="modal_cancel"
              onClick={this.messageToggleCycle}
            >
              Cancel
            </button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.cancelMessageModalCycle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

      </div>
    );
  }
}

export default reduxForm({
  form: "Upload Master",
})(withTranslation("common")(HorizontalForm));